<template>

    <div v-for="checkbox in list" class="checkbox-group">
        <input type="checkbox" :id="checkbox.key" :value="checkbox.value" v-model="value"/>
        <label :for="checkbox.key" class="checkbox-label">{{checkbox.label}}</label>
    </div>


</template>

<script>


export default {
    name: "InputCheckboxes"

}
</script>

<script setup>

import { ref, watch, computed } from "vue";
import { useStore }   from "vuex";
import { getValue, getList }        from "../composables/useData";
let store = useStore();

let props = defineProps(["field", "data", "datastore"]);
let emits = defineEmits(["update", 'clearErrors'])
let value = ref (/*useData.*/getValue(props.field, store.state, "user.profile")  ?? [] );

let list = computed ( () => /*useData.*/getList(props.field, props.data, props.datastore));


watch (value, () =>
{
    emits("update", {key: props.field.key, value: value.value});
    emits("clearErrors");
} )


function hasField (fields)
{
    let strKey = props.field.key;

    return fields.includes(strKey);
}

function getKey ()
{
    return props.field.key;
}

defineExpose({ hasField, getKey });

</script>
<style scoped>

</style>
